<div class="container">
	<ion-text class="date" [color]="item.appointment.status === 'done' ? 'primary' : ''">{{
		item.appointment.expectedDate |
		dateWithLocale:
		'fr-FR' : 'dd/MM HH:mm'
		}}</ion-text>
	<ion-img [src]="item.customer?.tradingLogo?.url" class="logo ion-no-margin ion-no-padding" slot="end"></ion-img>
	<div>
		<ion-text class="city">{{ item.appointment.address.city }}</ion-text>
		<ion-text>{{ item.appointment.clientId }}</ion-text>
	</div>
</div>